module.exports = __webpack_public_path__ + "static/media/banner3.38d84793.png";